export default {
      id: "ic_return_gray_bg_gray-usage",
      viewBox: "0 0 32 32",
      url: "/" + "images/icons.3.109.2.svg#ic_return_gray_bg_gray-usage",
      toString: function () {
        return this.url;
      }
    }